export const GlobalCheckboxPreset = {
  AcceptsMarketing: 'acceptsMarketing',
  AcceptsTerms: 'acceptsTerms',
  DefaultAddress: 'isDefaultAddress',
} as const

export type GlobalCheckboxPreset =
  typeof GlobalCheckboxPreset[keyof typeof GlobalCheckboxPreset]
